var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_8591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.24476 12.6345C4.4417 12.9399 4.70422 13.1893 5.00991 13.3616C5.3156 13.5339 5.65539 13.624 6.00031 13.624C6.34522 13.624 6.68501 13.5339 6.9907 13.3616C7.29639 13.1893 7.55891 12.9399 7.75585 12.6345L11.2642 7.1913C11.5811 6.70221 11.7088 6.09911 11.6202 5.51011C11.3978 4.07577 10.7111 2.77295 9.68202 1.83326C8.65297 0.893563 7.34831 0.37793 5.99997 0.37793C4.65162 0.37793 3.34696 0.893563 2.31791 1.83326C1.28886 2.77295 0.602093 4.07577 0.379706 5.51011C0.291196 6.09911 0.418902 6.70217 0.735753 7.1913L4.24406 12.6345",
    stroke: "#251F2C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 7.22124C7.31907 7.22124 8.38847 6.06784 8.38847 4.64505C8.38847 3.22225 7.31907 2.06885 5.9999 2.06885C4.68073 2.06885 3.61133 3.22225 3.61133 4.64505C3.61133 6.06784 4.68073 7.22124 5.9999 7.22124Z",
    stroke: "#251F2C",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_8591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBlack);
export default __webpack_public_path__ + "static/media/map_black.90c7af3ff593e0d041f0b31b71ce9f3d.svg";
export { ForwardRef as ReactComponent };